















































































































import { Component, Prop, Watch } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { SwCheckbox } from '@libs-uuif/shared/sw-checkbox';
import { SwIconButton } from '@libs-uuif/shared/sw-icon-button';
import { SwIcon } from '@libs-uuif/shared/sw-icon';
import { SwRadio } from '@libs-uuif/shared/sw-radio';
import { VNode, CreateElement } from 'vue';
import { tooltip, TooltipDirValues } from '@libs-uuif/shared/tooltip-dir';

const cssPrefix = 'sw-capture-client-reports';

@Component({
  components: {
    SwCheckbox,
    SwIconButton,
    SwIcon,
    SwRadio,
  },
  directives: {
    tooltip,
  },
})
export default class SwCaptureClientReports extends SwExtendedVue {
  cssPrefix = cssPrefix;

  @Prop({ type: Boolean, required: true, default: false })
  isClicked: boolean;

  @Prop({ type: Object, required: false })
  editReportData: any;

  @Prop({ type: Boolean, required: true, default: false })
  isReportEdit: boolean;

  @Prop({ type: Boolean, required: true, default: false })
  isModalClose: boolean;

  @Prop({ type: Boolean, required: false, default: false })
  isSelectAll: boolean;

  isCheckedValue: boolean[] = [false, false, false, false, false, false, false];
  onlyBasicValue = ['atp', 'devices', 'applications', 'tenants'];

  dataset = [
    {
      name: this.$t('spog.unifiedInsights.threats')
      .toString(),
      actualName: 'threats',
      content: 'none',
      options: [0, 3],
    },
    {
      name: this.$t('spog.unifiedInsights.catpEvents')
      .toString(),
      actualName: 'atp',
      content: 'none',
      options: [1, 4],
    },
    {
      name: this.$t('spog.unifiedInsights.devices')
      .toString(),
      actualName: 'devices',
      content: 'none',
      options: [2, 5],
    },
    {
      name: this.$t('spog.unifiedInsights.activities')
      .toString(),
      actualName: 'activities',
      content: 'none',
    },
    {
      name: this.$t('spog.unifiedInsights.webProtect')
      .toString(),
      actualName: 'webProtection',
      content: 'none',
    },
    {
      name: this.$t('spog.unifiedInsights.apps')
      .toString(),
      actualName: 'applications',
      content: 'none',
      options: [7, 8],
    },
    {
      name: this.$t('workflow.dashboard.tenants')
      .toString(),
      actualName: 'tenants',
      content: 'none',
      options: [6],
    },
  ];

  displayDataTooltip = [
    [
      {
        name: 'Basic',
        value: this.$t('spog.unifiedInsights.ccrTooltips.tooltip1')
        .toString(),
      },
      {
        name: 'Basic',
        value: this.$t('spog.unifiedInsights.ccrTooltips.tooltip2')
        .toString(),
      },
      {
        name: 'Detailed',
        value: this.$t('spog.unifiedInsights.ccrTooltips.tooltip3')
        .toString(),
      },
      {
        name: 'Threat-History',
        value:this.$t('spog.unifiedInsights.ccrTooltips.tooltip4')
        .toString(),
      },
    ],
    [
      {
        name: 'Basic',
        value: this.$t('spog.unifiedInsights.ccrTooltips.tooltip5')
        .toString(),
      },
      {
        name: 'ATP-History',
        value: this.$t('spog.unifiedInsights.ccrTooltips.tooltip6')
        .toString(),
      },
    ],
    [
      {
        name: 'Basic',
        value: this.$t('spog.unifiedInsights.ccrTooltips.tooltip7')
        .toString(),
      },
      {
        name: 'Basic',
        value: this.$t('spog.unifiedInsights.ccrTooltips.tooltip8')
        .toString(),
      },
      {
        name: 'Device-History',
        value: this.$t('spog.unifiedInsights.ccrTooltips.tooltip9')
        .toString(),
      },
      {
        name: 'Device-List',
        value: this.$t('spog.unifiedInsights.ccrTooltips.tooltip10')
        .toString(),
      },
    ],
    [
      {
        name: 'Basic',
        value: this.$t('spog.unifiedInsights.ccrTooltips.tooltip11')
        .toString(),
      },
      {
        name: 'Detailed',
        value: this.$t('spog.unifiedInsights.ccrTooltips.tooltip12')
        .toString(),
      },
    ],
    [
      {
        name: 'Basic',
        value: this.$t('spog.unifiedInsights.ccrTooltips.tooltip13')
        .toString(),
      },
      {
        name: 'Detailed',
        value: this.$t('spog.unifiedInsights.ccrTooltips.tooltip14')
        .toString(),
      },
    ],
    [
      {
        name: 'Basic',
        value: this.$t('spog.unifiedInsights.ccrTooltips.tooltip15')
        .toString(),
      },
      {
        name: 'Basic',
        value: this.$t('spog.unifiedInsights.ccrTooltips.tooltip16')
        .toString(),
      },
      {
        name: 'Risky-App-List',
        value: this.$t('spog.unifiedInsights.ccrTooltips.tooltip17')
        .toString(),
      },
      {
        name: 'Risky-Device-List',
        value: this.$t('spog.unifiedInsights.ccrTooltips.tooltip18')
        .toString(),
      },
    ],
    [
      {
        name: 'Basic',
        value: this.$t('spog.unifiedInsights.ccrTooltips.tooltip19')
        .toString(),
      },
      {
        name: 'Tenant-List',
        value: this.$t('spog.unifiedInsights.ccrTooltips.tooltip20')
        .toString(),
      },
    ],
  ];

  optionStatus = [
    {
      name: 'threatHistory',
      actualName: this.$t('spog.unifiedInsights.optStatus.opt1')
      .toString(),
      content: false,
    },
    {
      name: 'atpHistory',
      actualName: this.$t('spog.unifiedInsights.optStatus.opt2')
      .toString(),
      content: false,
    },
    {
      name: 'deviceHistory',
      actualName: this.$t('spog.unifiedInsights.optStatus.opt3')
      .toString(),
      content: false,
    },
    {
      name: 'threatList',
      actualName: this.$t('spog.unifiedInsights.optStatus.opt4')
      .toString(),
      content: false,
    },
    {
      name: 'atpList',
      actualName: this.$t('spog.unifiedInsights.optStatus.opt5')
      .toString(),
      content: false,
    },
    {
      name: 'deviceList',
      actualName: this.$t('spog.unifiedInsights.optStatus.opt6')
      .toString(),
      content: false,
    },
    {
      name: 'tenantList',
      actualName: this.$t('spog.unifiedInsights.optStatus.opt7')
      .toString(),
      content: false,
    },
    {
      name: 'riskyDevicesList',
      actualName: this.$t('spog.unifiedInsights.optStatus.opt8')
      .toString(),
      content: false,
    },
    {
      name: 'riskyAppsList',
      actualName: this.$t('spog.unifiedInsights.optStatus.opt9')
      .toString(),
      content: false,
    },
  ];
  enableFlag:boolean = false;

  /**
    @desc This function will select/deselect all report content when click on select all
  */
  private selectReportContent(isSelectAll:boolean) {
    let count = 0;
    this.isCheckedValue  = this.isCheckedValue.map(() => { return isSelectAll; });
    this.isCheckedValue.map(() => { this.changeValue(count); count += 1; });
    this.optionStatus.map((entry: { name: string; actualName: string; content: boolean }) => {
      entry.content = isSelectAll;
    });
  }

  /**
    @desc This function will check selectAll checkbox to select/deselect
  */
  @Watch('isSelectAll')
  selectAllContent() {
    if (this.isSelectAll) {
      this.selectReportContent(this.isSelectAll);
    }else if (!this.enableFlag) {
      this.selectReportContent(this.isSelectAll);
    }
  }

  /**
    @desc This function will call when the user hovers on the help icon
  */
  getTooltipValue(approvers: any[], index: number): TooltipDirValues {
    return {
      enabled: true,
      // tslint:disable-next-line
      content: (h: CreateElement): VNode => {
        const nodes: VNode[] = [];
        approvers[index].map((approver: any) => {
          nodes.push(
            (
              <div>
                {approver.name} : {approver.value}
              </div>
            ) as VNode,
          );
        });
        return (<div>{nodes}</div>) as VNode;
      },
      placement: 'right',
      compact: true,
      maxWidth: 350,
    };
  }

  private changeValue(index: number) {
    if (this.isCheckedValue[index]) {
      this.dataset[index].content === 'none' && (this.dataset[index].content = 'basic');
    } else {
      this.dataset[index].content = 'none';
    }
  }

  @Watch('isCheckedValue', { deep:true })
  @Watch('optionStatus', { deep:true })
  checkSelectAllOption() {
    if (this.getSelctedValuesCount() !== 9) {
      this.$emit('selectAll', false);
      this.enableFlag = true;
    }else {
      this.$emit('selectAll', true);
      this.enableFlag = false;
    }
  }

  /**
    @desc This function will call when the user opens the report-modal
  */
  @Watch('isModalClose')
  setDefaultValue() {
    this.isCheckedValue = [false, false, false, false, false, false, false];
    this.optionStatus.map((entry: any) => {
      entry.content = false;
    });
  }

  /**
    @desc This function will call when the user clicks on the edit button
  */
  @Watch('isReportEdit', { immediate: true })
  setEditReportData() {
    if (this.isReportEdit) {
      this.mapEditReportValue(this.editReportData.threatsSection, 0);
      this.mapEditReportValue(this.editReportData.atpSection, 1);
      this.mapEditReportValue(this.editReportData.devicesSection, 2);
      this.mapEditReportValue(this.editReportData.activitiesSection, 3);
      this.mapEditReportValue(this.editReportData.webProtectionSection, 4);
      this.mapEditReportValue(this.editReportData.applicationsSection, 5);
      this.mapEditReportValue(this.editReportData.tenantsSection, 6);
      this.optionStatus[0].content = this.editReportData.includeThreatHistory;
      this.optionStatus[1].content = this.editReportData.includeAtpHistory;
      this.optionStatus[2].content = this.editReportData.includeDeviceHistory;
      this.optionStatus[3].content = this.editReportData.includeThreatList;
      this.optionStatus[4].content = this.editReportData.includeAtpList;
      this.optionStatus[5].content = this.editReportData.includeDeviceList;
      this.optionStatus[6].content = this.editReportData.includeTenantList;
      this.optionStatus[7].content = this.editReportData.includeRiskyDevicesList;
      this.optionStatus[8].content = this.editReportData.includeRiskyAppsList;
      if (this.getSelctedValuesCount() === 9) {
        this.$emit('selectAll', true);
      }
    }
  }

  mapEditReportValue(val: string, index: number) {
    if (val === 'none') {
      this.isCheckedValue[index] = false;
    } else {
      this.isCheckedValue[index] = true;
      this.dataset[index].content = val;
    }
  }

  /**
    @desc TO check Whether all field selected or not
  */
  private getSelctedValuesCount():number {
    let selectedValueCount = 0;
    if (!this.isCheckedValue.includes(false)) {
      this.optionStatus.map((entry: any) => {
        entry.content && (selectedValueCount += 1);
      });
    }
    return selectedValueCount;
  }

  /**
    @desc This function will call when the user clicks on the save button
  */
  @Watch('isClicked')
  prepareDataset() {
    let labels = this.dataset.map((entry: any) => {
      return {
        name: entry.actualName,
        content: entry.content,
      };
    });
    labels = labels.concat(
      this.optionStatus.map((entry: any) => {
        return {
          name: entry.name,
          content: String(entry.content),
        };
      }),
    );
    this.$emit('receivedData', labels);
  }
}
